(() => {
  const initFooter = (section) => {
    if (!section || section.dataset.pmfpInitialized === 'true') return;
    section.dataset.pmfpInitialized = 'true';

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const accordions = Array.from(section.querySelectorAll('.pmfp-nav'));

    const setAccordionState = () => {
      const mobile = mobileQuery.matches;
      accordions.forEach((nav) => {
        const toggle = nav.querySelector('.pmfp-nav__toggle');
        const panel = nav.querySelector('.pmfp-nav__panel');
        if (!toggle || !panel) return;

        if (!mobile) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = '';
        } else {
          if (!nav.classList.contains('is-open')) {
            toggle.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = '0px';
          } else {
            toggle.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = `${panel.scrollHeight}px`;
          }
        }
      });
    };

    accordions.forEach((nav) => {
      const toggle = nav.querySelector('.pmfp-nav__toggle');
      const panel = nav.querySelector('.pmfp-nav__panel');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : '0px';
      });
    });

    const syncVisiblePanelHeights = () => {
      if (!mobileQuery.matches) return;
      accordions.forEach((nav) => {
        if (!nav.classList.contains('is-open')) return;
        const panel = nav.querySelector('.pmfp-nav__panel');
        if (panel) panel.style.maxHeight = `${panel.scrollHeight}px`;
      });
    };

    mobileQuery.addEventListener?.('change', setAccordionState);
    window.addEventListener('resize', syncVisiblePanelHeights, { passive: true });

    setAccordionState();
    syncVisiblePanelHeights();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.12 });
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }

    const form = section.querySelector('.pmfp__newsletter-form');
    if (form) {
      form.addEventListener('submit', () => {
        const button = form.querySelector('button[type="submit"]');
        if (button) {
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
        }
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-premium-mega-footer-pro]').forEach(initFooter);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-premium-mega-footer-pro]');
    if (section) initFooter(section);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector?.('[data-premium-mega-footer-pro]');
    if (section) section.dataset.pmfpInitialized = 'false';
  });
})();